import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { useStyles } from "./styles";
import { useTheme } from "@emotion/react";

export default function SimpleDropdown({
  lists,
  setDropdownValue,
  dataTestid,
  value = "",
}) {
  const theme = useTheme();
  const classes = useStyles({ theme });
  return (
    <Box sx={{ minWidth: 150 }}>
      <TextField
        classes={{ root: classes.simpleDropdown }}
        id="outlined-select-menu"
        select
        value={value || ""}
        fullWidth
        size="small"
        slotProps={{ inputLabel: { shrink: false } }}
        onChange={setDropdownValue}
        data-testid={dataTestid}
        className={classes.simpleDropdown}
      >
        {lists.map((option) => (
          <MenuItem
            key={option.Name}
            value={option.Name}
            className={classes.menuItem}
          >
            {option.Name}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}

SimpleDropdown.propTypes = {
  lists: PropTypes.any.isRequired,
  setDropdownValue: PropTypes.func.isRequired,
  dataTestid: PropTypes.string,
  value: PropTypes.string,
};
